import { Link, useNavigate } from "react-router-dom";
import "./Cart.css";

const Cart = ({
  cartItems,
  removeFromCart,
  updateQuantity,
  user,
  onOpenLogin,
}) => {
  const navigate = useNavigate();

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const shippingCost = subtotal >= 100 ? 0 : 15;
  const total = subtotal + shippingCost;

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      alert("Il tuo carrello è vuoto!");
      return;
    }

    if (!user) {
      alert("Devi accedere per procedere con l'ordine");
      onOpenLogin();
      return;
    }

    navigate("/checkout");
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-empty">
        <div className="empty-cart-content">
          <h2>🛒 Il tuo carrello è vuoto</h2>
          <p>Aggiungi alcuni prodotti per iniziare!</p>
          <Link to="/products" className="continue-shopping-btn">
            Continua lo Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h1>Carrello di Acquisto</h1>

        <div className="cart-content">
          <div className="cart-items-section">
            <table className="cart-table">
              <thead>
                <tr>
                  <th>Prodotto</th>
                  <th>Prezzo</th>
                  <th>Quantità</th>
                  <th>Totale</th>
                  <th>Azione</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((item) => (
                  <tr key={item.id} className="cart-item-row">
                    <td className="product-name-cell">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="cart-item-image"
                      />
                      <div className="product-info">
                        <h4>{item.name}</h4>
                        <small>Disponibili</small>
                      </div>
                    </td>

                    <td className="price-cell">
                      €{item.price.toFixed(2)}
                    </td>

                    <td className="quantity-cell">
                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity - 1)
                        }
                        className="qty-btn"
                      >
                        −
                      </button>
                      <input
                        type="number"
                        min="1"
                        value={item.quantity}
                        onChange={(e) =>
                          updateQuantity(item.id, parseInt(e.target.value) || 1)
                        }
                        className="qty-input"
                      />
                      <button
                        onClick={() =>
                          updateQuantity(item.id, item.quantity + 1)
                        }
                        className="qty-btn"
                      >
                        +
                      </button>
                    </td>

                    <td className="total-cell">
                      €{(item.price * item.quantity).toFixed(2)}
                    </td>

                    <td className="action-cell">
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="remove-btn"
                      >
                        🗑️ Rimuovi
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Link to="/products" className="continue-shopping-link">
              ← Continua lo Shopping
            </Link>
          </div>

          <aside className="cart-summary">
            <div className="summary-card">
              <h3>Riepilogo Ordine</h3>

              <div className="summary-row">
                <span>Subtotale:</span>
                <span>€{subtotal.toFixed(2)}</span>
              </div>

              <div className="summary-row">
                <span>Spedizione:</span>
                <span className="shipping-cost">
                  {shippingCost === 0 ? "GRATIS ✓" : `€${shippingCost.toFixed(2)}`}
                </span>
              </div>

              {subtotal >= 100 && (
                <div className="free-shipping-badge">
                  🎉 Hai diritto a spedizione gratis!
                </div>
              )}

              <div className="summary-row total-row">
                <span>Totale:</span>
                <span className="total-amount">€{total.toFixed(2)}</span>
              </div>

              <div className="user-status">
                {user ? (
                  <p className="logged-in">✓ Accedi come: <strong>{user.name}</strong></p>
                ) : (
                  <p className="not-logged-in">⚠️ Accedi per continuare</p>
                )}
              </div>

              <button
                onClick={handleCheckout}
                className="checkout-btn"
                disabled={!user}
              >
                {user ? "Procedi al Pagamento →" : "Accedi per Continuare"}
              </button>

              {!user && (
                <button onClick={onOpenLogin} className="login-btn">
                  👤 Accedi Ora
                </button>
              )}

              <div className="payment-methods">
                <p>Metodi accettati:</p>
                <div className="payment-icons">
                  <span title="Carta di Credito">💳</span>
                  <span title="PayPal">🅿️</span>
                  <span title="Bonifico">🏦</span>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Cart;
